import { render, staticRenderFns } from "./MainMenuTile.vue?vue&type=template&id=907b5d4c&"
import script from "./MainMenuTile.vue?vue&type=script&lang=ts&"
export * from "./MainMenuTile.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenuTile.vue?vue&type=style&index=0&id=907b5d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports